import { component } from 'picoapp';

export default component(async (node) => {
  const btn = node.querySelector('[data-accordion-btn]');
  const content = node.querySelector<HTMLElement>('[data-accordion-content]');
  const iconInactive = node.querySelector<HTMLElement>('[data-icon-inactive]');
  const iconActive = node.querySelector<HTMLElement>('[data-icon-active]');

  const init = () => {
    btn.addEventListener('click', () => {
      content.hidden = !content.hidden;

      if (iconInactive) iconInactive.hidden = !content.hidden;
      if (iconActive) iconActive.hidden = content.hidden;
    });
  };

  init();
});
